import React, { FC, useEffect } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import dynamic from 'next/dynamic';
import { TspInfo } from '@widgets/tsp-info';
import { FAQ } from '@widgets/faq';
import { SbpQrModalDesktop } from '@widgets/sbp-qr-modal';
import { DenominationListWithPicker } from '@widgets/denomination';
import { TspPaymentFormSection } from '@widgets/payment';
import { ResultModal } from '@widgets/result';
import { TspPaymentForm } from '@features/payment/payment-form';
import { getTspEventContent } from '@features/payment/payment-form/lib/getTspEventContent';
import { CommissionDataByServiceIdType, DenominationAmountByServiceIdType } from '@entities/denomination';
import { getFaqForTspPage } from '@entities/faq';
import { ServerOption } from '@entities/server';
import { TspPageDenomination, TspPagePayee, getTspListLabelByTspType, getTspListPathByTspType } from '@entities/tsp';
import { FetchHintsResponseType } from '@entities/hint';
import { tspPageShowGtm } from '@shared/lib/gtm/redesign';
import { useCurrentTspOnly } from '@shared/lib';
import { usePartner } from '@shared/lib/partner';
import { withTheme } from '@shared/lib/theme';
import { Breadcrumbs, Carousel } from '@shared/ui/organisms';
import { Text } from '@shared/ui/atoms';
import { ICON_TCP } from '@shared/config';
const DynamicAnimatedBackground = dynamic(() => import('@shared/ui/organisms').then(imported => imported.AnimatedBackground), {
  ssr: false
});
interface TspFormPageViewProps {
  h1: string;
  payee: TspPagePayee;
  countryVouchers: {
    country: string;
    icon: string;
  }[];
  denominationsByCountry: Record<string, TspPageDenomination[]>;
  pricesByServiceId: DenominationAmountByServiceIdType;
  servers: ServerOption[];
  hints: FetchHintsResponseType;
  commissionData: CommissionDataByServiceIdType;
}
const TspFormPageView: FC<TspFormPageViewProps> = ({
  h1,
  payee,
  countryVouchers,
  denominationsByCountry,
  pricesByServiceId,
  servers,
  commissionData
}) => {
  const {
    partner
  } = usePartner();
  const {
    isCurrentTspOnly
  } = useCurrentTspOnly();
  useEffect(() => {
    const eventContent = getTspEventContent(payee);
    tspPageShowGtm(eventContent, {
      productName: payee.providerName
    });
  }, [payee]);
  return <TspFormPageViewWrapper>
      <NotScrollableContentWrapper>
        {payee.features?.backgroundcategory ? <ImageWrapper>
            <Image src={`${ICON_TCP}${payee.features.backgroundcategory}`} alt="background" width={1920} height={552} />
          </ImageWrapper> : <DynamicAnimatedBackground />}
        {!isCurrentTspOnly && <BreadcrumbsWrapper>
            <Carousel>
              <Breadcrumbs size="m" items={[{
            label: getTspListLabelByTspType(payee),
            href: getTspListPathByTspType(payee)
          }, {
            label: h1
          }]} />
            </Carousel>
          </BreadcrumbsWrapper>}
      </NotScrollableContentWrapper>
      <ScrollableContentWrapper>
        <TspPaymentForm h1={h1} payee={payee} countryVouchers={countryVouchers} denominationsByCountry={denominationsByCountry} pricesByServiceId={pricesByServiceId} servers={servers} commissionData={commissionData}
      // hints={hints}
      renderTspInfo={props => <TspInfo {...props} />} renderDenominationList={props => <DenominationListWithPicker {...props} />} renderPaymentForm={props => <TspPaymentFormSection {...props} />} renderQrModal={props => <SbpQrModalDesktop {...props} />} renderResultModal={props => <ResultModal {...props} />} />
        <FAQWrapper>
          <Text family="MTSWide" size={{
          desktop: 'h4',
          mobile: 'pL'
        }} weight="black" color="primary" textTransform="uppercase">
            Вопросы и ответы
          </Text>
          <FAQ items={getFaqForTspPage(payee, partner)} />
        </FAQWrapper>
      </ScrollableContentWrapper>
    </TspFormPageViewWrapper>;
};
export default TspFormPageView;
const TspFormPageViewWrapper = /*#__PURE__*/styled('div')({
  name: "TspFormPageViewWrapper",
  class: "thpzpvw",
  propsAsIs: false
});
const NotScrollableContentWrapper = /*#__PURE__*/styled('div')({
  name: "NotScrollableContentWrapper",
  class: "n32cmgi",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "im2yvn3",
  propsAsIs: false
});
const BreadcrumbsWrapper = /*#__PURE__*/styled('div')({
  name: "BreadcrumbsWrapper",
  class: "bhg82nn",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ScrollableContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ScrollableContentWrapper",
  class: "s1ajh3hl",
  propsAsIs: false,
  vars: {
    "s1ajh3hl-0": [_exp()]
  }
}));
const FAQWrapper = /*#__PURE__*/styled('div')({
  name: "FAQWrapper",
  class: "fn5sfuh",
  propsAsIs: false
});

require("./TspFormPageView.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TspFormPageView.tsx");